module.exports = __webpack_public_path__ + "img/help_btn.ecb33a6b.png";